import { apiRoutes } from '../../../api-routes';
import { accountsUrl } from '../../../constants';
import { publicHttpClient } from '../../../util/http-client';
import type { LoginRequestBody } from '../login-fn';
import type { LoginResponse } from '../types';

export const accountsloginFn = async (body: LoginRequestBody) => {
  const params = {
    ...body,
    ahamove_sms_auth: true,
    country_code: 'VN',
  };

  const response = await publicHttpClient.post<LoginResponse>(
    accountsUrl + apiRoutes.accounts.login,
    params,
    {
      withCredentials: true,
    }
  );
  return response.data;
};
